import { notifications } from '@mantine/notifications';
import { current } from '@reduxjs/toolkit';
import messages from '@shared/constants/messages';
import { OfflineOrderingState } from '../types';

const editRemove = (state: OfflineOrderingState, menuItemId: string): OfflineOrderingState => {
  const findIndex = current(state.menus || []).findIndex((x) => x.menuItemId === menuItemId);
  const find = current(state?.menus || [])[findIndex];
  if (find?.count === 1) {
    const orderOrderItems = state?.menus
      ?.filter((x) => x.tempId !== find.tempId)
      .reduce((acc, cur) => acc + (cur?.count || 0), 0);

    if (orderOrderItems === 0) {
      notifications.show({
        message: messages.NOT_ALLOW_REMOVE_ALL_ITEMS,
        color: 'red',
      });
      return { ...state };
    }
    return {
      ...state,
      menus: current(state?.menus || []).filter((_, i) => i !== findIndex),
    };
  }
  return {
    ...state,
    menus: current(state?.menus || []).map((item, index) => {
      if (index === findIndex) {
        return {
          ...item,
          count: (item?.count || 0) - 1,
          orderItemToppings: item?.orderItemToppings?.map((x) => ({
            ...x,
            count: (item.count || 0) - 1,
          })),
        };
      }
      return item;
    }),
  };
};

const removeItemFromMenu = (state: OfflineOrderingState, menuItemId: string): OfflineOrderingState => {
  if (state.isEdited) {
    return editRemove(state, menuItemId);
  }
  const findIndex = current(state.menus).findIndex((x) => x.menuItemId === menuItemId);
  const find = current(state.menus)[findIndex];
  if (find?.count === 1) {
    return {
      ...state,
      menus: current(state.menus).filter((_, i) => i !== findIndex),
    };
  }
  return {
    ...state,
    menus: current(state.menus).map((item, index) => {
      if (index === findIndex) {
        return {
          ...item,
          count: (item?.count || 0) - 1,
          orderItemToppings: item?.orderItemToppings?.map((x) => ({
            ...x,
            count: (item.count || 0) - 1,
          })),
        };
      }
      return item;
    }),
  };
};

export default removeItemFromMenu;
